import createImageUrlBuilder from "@sanity/image-url";
import ProvincesMaroc from "assets/ProvincesMaroc/ProvincesMaroc.json";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import BudgetHeader from "SanityComponents/CalculezVotreBudgetComponents/BudgetHeader/BudgetHeader";
import Footer from "SanityComponents/Footer/Footer";
import ThreeGuideButtons from "SanityComponents/GuideDuCredit/ThreeGuideButtons";
import Cards from "SanityComponents/LandingPage/Cards";
import LpPrixImmobilier from "SanityComponents/LandingPage/LpPrixImmobilier";
import ThreeButtons from "SanityComponents/LandingPage/ThreeButtons";
import Question from "SanityComponents/Question/Question";
import formatUrl from "utils/FormatUrl";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import EstimationHeader from "../SanityComponents/CreditImmobilierComponents/EstimationHeader";
import Card from "../SanityComponents/GuideDuCredit/GuideCards";
import style from "./style.module.css";
import FAQ from "SanityComponents/FAQ/FAQ";
import WhatssapComponent from "SanityComponents/WhatssapComponent";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function GuideCreditCategory(props) {
  const { t, lang } = useTranslation("LandingPage");

  const { data, posts, postsUrl } = props;
  return (
    <div className={style.header}>
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <div
              style={{
                backgroundColor: "rgba(245, 245, 245)",
              }}
            >
              <div
                style={{
                  padding: "64px 0px",
                }}
              >
                <BudgetHeader
                  title={item.titre ? item.titre[lang] : ""}
                  subtitle={item.soustitre ? item.soustitre[lang] : ""}
                />
              </div>
              {posts.length > 0 ? (
                <div className={style.guideCardsParentContainer}>
                  <div className={style.postsCardsContainer}>
                    {posts.map((elem, index) => {
                      return (
                        <a
                          href={formatUrl(
                            `${postsUrl}/${elem.slug.current}`,
                            lang
                          )}
                          rel={
                            elem?.slug?.current?.includes("list") ||
                              elem?.slug?.current?.includes("map") ||
                              elem?.slug?.current?.includes("?") ||
                              elem?.slug?.current?.includes("conditions") ||
                              elem?.slug?.current?.includes("contact")
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                        >
                          <Card
                            image={
                              elem.mainImage &&
                              urlFor(elem.mainImage)
                                .width(404)
                                .height(187)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            }
                            width={elem.width <= 404 ? elem.width : 404}
                            height={elem.height <= 187 ? elem.height : 187}
                            title={elem.title ? elem.title[lang] : ""}
                            subtitle={
                              elem.subtitle ? elem.subtitle[lang] : null
                            }
                            date={elem._createdAt}
                            lang={lang}
                          />
                        </a>
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          );
        } else if (item._type == "GuideThreeButtons") {
          return (
            <>
              <ThreeGuideButtons
                slug={data.slug.current}
                button1={item.button1 ? item.button1[lang] : ""}
                link_button1={item.link_button1}
                button2={item.button2 ? item.button2[lang] : ""}
                link_button2={item.link_button2}
                button3={item.button3 ? item.button3[lang] : ""}
                link_button3={item.link_button3}
                lang={lang}
              />
            </>
          );
        } else if (item._type == "ThreeButtons") {
          return (
            <>
              <ThreeButtons
                btn1={item.titre_button1 ? item.titre_button1[lang] : ""}
                // link1 = {elem.button_link1[lang]}

                btn2={item.titre_button2[lang]}
                // link2 = {elem.button_link2[lang]}

                btn3={item.titre_button3[lang]}
                // link3 = {elem.button_link3[lang]}
                provinces={ProvincesMaroc}
                t={t}
              />
            </>
          );
        } else if (item._type == "QuestionImmobilier") {
          return (
            <div>
              <Question
                title={item.titre ? item.titre[lang] : ""}
                text={item.text ? item.text[lang] : ""}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                image={urlFor(item.mainImage)
                  .format("webp")
                  .auto("format")
                  .fit("clip")
                  .auto("format")
                  .toString()}
                button_link={item.button_link}
              />
            </div>
          );
        } else if (item._type == "LpPrixImmobilier") {
          return (
            <div className={style.simulez}>
              <LpPrixImmobilier
                title={item.titre ? item.titre[lang] : ""}
                texte={item.texte[lang]}
                buttonText={item.button_text ? item.button_text[lang] : ""}
                button_link={item.button_link}
              />
            </div>
          );
        } else if (item.LandingPageCards) {
          return (
            <>
              {item.LandingPageCards && item.LandingPageCards.length > 0 ? (
                <>
                  <div>
                    {item.LandingPageCards.map((elem, index) => {
                      return (
                        <>
                          {elem && (
                            <Cards
                              titre={elem.titre[lang]}
                              texte={elem.text[lang]}
                              button_text={elem.button_text[lang]}
                              lien1={elem.lien1 ? elem.lien1[lang] : null}
                              href1={elem.href1}
                              lien2={elem.lien2 ? elem.lien2[lang] : null}
                              href2={elem.href2}
                              button_link={elem.button_link}
                              image={
                                elem.mainImage
                                  ? urlFor(elem.mainImage)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()
                                  : null
                              }
                              t={t}
                            />
                          )}
                        </>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </>
          );
        } else if (item.GuidCreditPageCards) {
          return (
            <>
              {item.GuidCreditPageCards?.GuidCreditPageCards?.length > 0 && (
                <div className={style.guideCardContainer}>
                  <div className={style.guideCardTitle}>
                    {item.GuidCreditPageCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidCreditPageCards?.titre[lang]}
                      </p>
                    )}

                    {/* {item.GuidCreditPageCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidCreditPageCards?.buttonLink?.includes(
                              "list"
                            ) ||
                              item.GuidCreditPageCards?.buttonLink?.includes(
                                "map"
                              ) ||
                              item.GuidCreditPageCards?.buttonLink?.includes(
                                "?"
                              ) ||
                              item.GuidCreditPageCards?.buttonLink?.includes(
                                "conditions"
                              ) ||
                              item.GuidCreditPageCards?.buttonLink?.includes(
                                "contact"
                              )
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidCreditPageCards?.buttonLink,
                            lang
                          )}
                        >
                          {item.GuidCreditPageCards?.button[lang]}
                        </a>
                      </p>
                    )} */}
                  </div>

                  {/* <div className={style.guideCardsParentContainer}> */}
                  <div className={style.postsCardsContainer}>
                    {item.GuidCreditPageCards?.GuidCreditPageCards?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                href={formatUrl(
                                  `guide-du-credit/${elem.slug.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={urlFor(elem.mainImage)
                                    .width(404)
                                    .height(187)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()}
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
                // </div>
              )}
            </>
          );
        } else if (item.GuidAcheteurCards) {
          return (
            <div className={style.guideCardsParentContainer}>
              {item.GuidAcheteurCards?.GuidAcheteurCardsArray?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                  style={{ top: "0px" }}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidAcheteurCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidAcheteurCards?.titre[lang]}
                      </p>
                    )}

                    {/* {item.GuidAcheteurCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "list"
                            ) ||
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "map"
                            ) ||
                            item.GuidAcheteurCards?.buttonLink?.includes("?") ||
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "conditions"
                            ) ||
                            item.GuidAcheteurCards?.buttonLink?.includes(
                              "contact"
                            )
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidAcheteurCards?.buttonLink,
                            lang
                          )}
                        >
                          {item.GuidAcheteurCards?.button[lang]}
                        </a>
                      </p>
                    )} */}
                  </div>

                  <div className={style.postsCardsContainer}>
                    {item.GuidAcheteurCards?.GuidAcheteurCardsArray?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                href={formatUrl(
                                  `/acheter/guide/${elem?.slug?.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={
                                    elem?.mainImage
                                      ? urlFor(elem?.mainImage)
                                        .width(404)
                                        .height(187)
                                        .format("webp")
                                        .auto("format")
                                        .fit("clip")
                                        .auto("format")
                                        .toString()
                                      : null
                                  }
                                  title={elem?.title ? elem?.title[lang] : ""}
                                  subtitle={
                                    elem?.subtitle ? elem?.subtitle[lang] : ""
                                  }
                                  width={elem?.width ? elem?.width : 404}
                                  height={elem?.height ? elem?.height : 187}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        } else if (item.GuidLocationCards) {
          return (
            <>
              {item.GuidLocationCards?.GuidLocationCardsArray?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                  style={{ top: "0px" }}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidLocationCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidLocationCards?.titre[lang]}
                      </p>
                    )}

                    {item.GuidLocationCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          rel={
                            item.GuidLocationCards?.buttonLink?.includes(
                              "list"
                            ) ||
                              item.GuidLocationCards?.buttonLink?.includes(
                                "map"
                              ) ||
                              item.GuidLocationCards?.buttonLink?.includes("?") ||
                              item.GuidLocationCards?.buttonLink?.includes(
                                "conditions"
                              ) ||
                              item.GuidLocationCards?.buttonLink?.includes(
                                "contact"
                              )
                              ? "nofollow noopener noreferrer noindex"
                              : "follow"
                          }
                          href={formatUrl(
                            item.GuidLocationCards?.buttonLink,
                            lang
                          )}
                        >
                          {item.GuidLocationCards?.button[lang]}
                        </a>
                      </p>
                    )}
                  </div>

                  <div className={style.postsCardsContent}>
                    {item.GuidLocationCards?.GuidLocationCardsArray?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                href={formatUrl(
                                  `/louer/guide-location/${elem.slug.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={urlFor(elem.mainImage)
                                    .width(404)
                                    .height(187)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()}
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item.GuidPrixCards) {
          return (
            <>
              {item.GuidPrixCards?.GuidPrixCardsArray?.length > 0 && (
                <div
                  className={style.guideCardContainer}
                  style={{ top: "0px" }}
                >
                  <div className={style.guideCardTitle}>
                    {item.GuidPrixCards?.titre && (
                      <p className={style.guidetitle}>
                        {item.GuidPrixCards?.titre[lang]}
                      </p>
                    )}

                    {item.GuidPrixCards?.button && (
                      <p className={style.guidebtn}>
                        <a
                          href={formatUrl(item.GuidPrixCards?.buttonLink, lang)}
                        >
                          {item.GuidPrixCards?.button[lang]}
                        </a>
                      </p>
                    )}
                  </div>

                  <div className={style.postsCardsContent}>
                    {item.GuidPrixCards?.GuidPrixCardsArray?.map(
                      (elem, index) => {
                        return (
                          <>
                            {elem && (
                              <a
                                href={formatUrl(
                                  `/guide-du-prix/${elem.slug.current}`,
                                  lang
                                )}
                              >
                                <Card
                                  image={urlFor(elem.mainImage)
                                    .width(404)
                                    .height(187)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()}
                                  title={elem.title ? elem.title[lang] : ""}
                                  subtitle={
                                    elem.subtitle ? elem.subtitle[lang] : ""
                                  }
                                  width={elem.width ? elem.width : 404}
                                  height={elem.height ? elem.height : 187}
                                />
                              </a>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          );
        } else if (item._type == "Faq") {
          return <FAQ data={item} lang={lang} />;
        } else if (item._type == "SanityHeadSeo") {
          return (
            <SanityHeadSeo
              key={key}
              title={item.titre ? item.titre[lang] : ""}
              ogTitle={item.titre ? item.titre[lang] : ""}
              description={item.description ? item.description[lang] : ""}
              ogDescription={item.description ? item.description[lang] : ""}
              canonicalUrl={item.canonicalUrl}
              ogTwitterImage={
                item.mainImage
                  ? urlFor(item.mainImage)
                    .width(250)
                    .height(250)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()
                  : null
              }
              ogType={item.ogType}
              ogImageUrl={
                item.mainImage
                  ? urlFor(item.mainImage)
                    .width(250)
                    .height(250)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()
                  : null
              }
              structuredData={null}
            >
              <></>
            </SanityHeadSeo>
          );
        } else if (item._type == "SanityFooter") {
          return (
            <>
              <div className={style.footer}>
                <div className={style.footerDesk}>
                  <Footer
                    propos={item.propos[lang]}
                    proposText={item.text ? item.text[lang] : ""}
                    donnee={item.donnees[lang]}
                    donneeText={item.textdonnee[lang]}
                    technologie={item.technologie[lang]}
                    technologieText={item.texttechnologies[lang]}
                    logo={urlFor(item.agenz_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    facebook={urlFor(item.facebook_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    instagram_logo={urlFor(item.instagram_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    linked_in={urlFor(item.linkedin_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    socialMediaText={item.socialMediatext}
                    copyRightText={item.permission_text}
                  />
                </div>
                {/* <div className={style.footerMobile}>
                        <MobileFooter/>
                    </div> */}
              </div>
            </>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
